<div>
    <p-progressBar [value]="progress" [showValue]="showValue"></p-progressBar>
</div>
